import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
} from 'react-stripe-elements';
import bodymovin from 'bodymovin';

import ArrowRight from 'assets/images/arrow-right.svg';
import {
  ButtonWrapper,
  inputStyle,
  loaderStyle,
  wrapperStyle,
} from './StripeStyles';


class StripeCheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // error: false,
      submitted: false,
      ready: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ ready: true });
    }, 2200);

    bodymovin.loadAnimation({
      container: document.getElementById('loader'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('assets/images/icons/loader.json'),
    });
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    if (!this.state.submitted) {
      this.setState({
        // error: false,
        submitted: true,
      });
      this.props.stripe.createToken({ name: this.props.name }).then(({ token }) => {
        if (token !== null && typeof token === 'object') {
          this.setState({ ready: false });
          this.props.onSuccess(token);
        } else {
          this.setState({
            // error: true,
            submitted: false,
          });
        }
      });
    }
  }

  render() {
    const { ready } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        {!ready && <span id="loader" style={loaderStyle} />}
        <div id="stripe-wrapper" style={{ opacity: ready ? 1 : 0 }}>
          <div style={wrapperStyle}>
            <CardNumberElement style={inputStyle} placeholder="Card number*" />
          </div>
          <div style={wrapperStyle}>
            <CardExpiryElement style={inputStyle} placeholder="Expiry date (MM/YY)*" />
          </div>
          <div style={wrapperStyle}>
            <CardCVCElement placeholder="CVC*" style={inputStyle} />
          </div>
          <div style={wrapperStyle}>
            <PostalCodeElement placeholder="Postal code*" style={inputStyle} />
          </div>
        </div>
        {/* @TODO: Error message here... */}
        <ButtonWrapper type="submit">
          <p className="caption">
            {ready
              ? 'Pay now'
              : 'Please wait...'
            }
          </p>
          <img alt="Arrow" src={ArrowRight} />
        </ButtonWrapper>
      </form>
    );
  }
}

StripeCheckoutForm.propTypes = {
  name: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  stripe: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectStripe(StripeCheckoutForm);



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Stripe/StripeCheckoutForm.js